module.exports = __webpack_public_path__ + "media/PAG87-07.05b001fd.mp3";